import api from './core/api';

export interface AuthProfile {
  _id: string;
  firstName: string;
  lastName?: string;
  email?: string;
  phone?: string;
  userType: string;
  avatar?: string;
  metadata?: { dateOfBirth?: string };
}

export async function getAuthProfile() {
  const res = await api.get('/auth/profile');
  return res.data.data as AuthProfile;
}

export async function updateAuthProfile(payload: {
  firstName?: string;
  lastName?: string;
  email?: string;
}) {
  const res = await api.put('/auth/profile', payload);
  return res.data.data as AuthProfile;
}
